module.exports = __webpack_public_path__ + "static/graph-3-2502b64815b9d8d907d32b63271f906d.svg";